import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectRepeatComponent } from './select-repeat/select-repeat.component';
import { ScheduleQuickstartComponent } from './schedule-quickstart.component';
import { SelectActionComponent } from './../select-action/select-action.component';
import { ScheduleListComponent } from './schedule-list/schedule-list.component';
import { AddScheduleComponent } from './add-schedule/add-schedule.component';


export const SCHEDULER_QUICKSTART_TRIGGER_ROUTES: Routes = [{
  path: 'schedule', component: ScheduleQuickstartComponent, children: [{
    path: '', redirectTo: 'list', pathMatch: 'full'
  }, {
    path: 'list', component: ScheduleListComponent
  }, {
    path: 'add', component: AddScheduleComponent
  }]
}];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/schedule-quickstart.routes.ts